import { AxiosError, AxiosPromise, AxiosResponse } from 'axios'
import { Delete } from './Delete'
import { Filter } from './Devices'
import { Get } from './Get'
import { UserProfileObject } from './organization.types'
import { Post } from './Post'
import { Put } from './Put'
import { ApiHelpers, APIHosts } from './ApiHelpers'

export interface UserResponse {
  id: string
  invitationStatus: string
  userName: string
  email: string
  phoneNumber: string
  firstname: string
  lastname: string
  avatarUrl: string
  forcePasswordChange: boolean
  profile: any
  userOrgId: string
  organizationRoles: string[]
  gender: string
  isActive?: boolean
}

export interface PageUserResponse {
  results: UserResponse[]
  page: number
  pageCount: number
  pageSize: number
  queryCount: number
  firstRowIndex?: number
  lastRowIndex?: number
}

export interface UpdateUserData {
  firstName?: string
  lastName?: string
  email?: string
  password?: string
  confirmPassword?: string
}

export interface GetUsersParams {
  page?: number
  pageSize?: number
  paging?: boolean
}

class AdminUserServiceController extends ApiHelpers {
  ApiHost = APIHosts.LicenseManager;

  public Get = {
    getAllUsers: (params?: GetUsersParams): AxiosPromise<PageUserResponse> => {
      const finalParams = {
        page: 1,
        pageSize: 10,
        ...params,
      }
      const query = new URLSearchParams()
      if (finalParams) {
        for (const key in finalParams) {
          const value = finalParams[key as keyof GetUsersParams]
          if (value !== undefined) {
            query.append(key, String(value))
          }
        }
      }
      const url = `${this.getHost(this.ApiHost) + '/users'}?${query}`
      return Get(url)
    },
    getRolesToUserId: (userId: string): AxiosPromise<string[]> => {
      const url = `${this.getHost(this.ApiHost) + '/users'}/${userId}/roles`
      return Get(url)
    },
  }

  public Put = {
    updateRolesUser: (userId: string, data: { roleName: string }) => {
      const url = `${this.getHost(this.ApiHost)}/users/${userId}/roles`
      return Put(url, data)
    },
    // ID-08: license-manager revoke session best-effort sau khi khoá — id nào revoke lỗi nằm trong revokeFailed.
    blockUser: (userId: string): AxiosPromise<{ revokeFailed?: string[] }> => {
      const url = `${this.getHost(this.ApiHost)}/users/deactivate`
      return Put(url, [userId])
    },
    unblockUser: (userId: string): AxiosPromise<any> => {
      const url = `${this.getHost(this.ApiHost)}/users/activate`
      return Put(url, [userId])
    },
  }

  public Delete = {
    deleteRolesUser: (userId: string, roleNames: string[]) => {
      const url = `${this.getHost(this.ApiHost)}/users/${userId}/roles`
      return Delete(url, roleNames)
    },
    deleteOrganization: (organizationId: string): AxiosPromise<any> => {
      const url = `${this.getHost(this.ApiHost)}/organizations/${organizationId}`
      return Delete(url)
    },
    removeUserFromOrganization: (
      organizationId: string,
      userId: string
    ): AxiosPromise<any> => {
      const url = `${this.getHost(this.ApiHost)}/organizations/${organizationId}/users`
      const data = [userId]
      return Delete(url, data)
    },
  }

  public Post = {
    createUser: (data: any) => {
      const url = `${this.getHost(this.ApiHost)}/organizations/users/register`
      return Post(url, data)
    },
  }
}

export const AdminUserService = new AdminUserServiceController()